module.exports = __webpack_public_path__ + "static/media/Apercu-Italic.f1b4c34e.woff";